import React from 'react'
import { Route, Routes } from 'react-router-dom'
import './App.css';
import Layout from './Component/Layout';
import Home from './Pages/Home.js'
import About from './Pages/About.js';
import Service from './Pages/Service.js';
import Contact from './Pages/Contact.js';


const App = () => {
  return (
    <>
    <Routes>
      <Route path='/' element={<Layout/>}>
        <Route path='' element={<Home />}></Route>
        <Route path='/about' element={<About/>}></Route>
        <Route path='/service/:category' element={<Service/>}></Route>
        <Route path='/contact' element={<Contact/>}></Route>
      </Route>
    </Routes>
    </>
  )
}

export default App